/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Delete } from '@mui/icons-material';
import StarIcon from '@mui/icons-material/Star';
import { Box, IconButton } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import TableComponent from '../../components/TableComponent';
import { showError, showToast } from '../../constants/toasts';
import { ConfirmationModal } from '../../Modals/confirmationModal';
import { SingleRating, useLazyGetUserRatingQuery } from '../../service/listing';
import { useDeleteRatingByIdMutation } from '../../service/rating';

const RatingsAndReviews = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [getRating] = useLazyGetUserRatingQuery();
  const [rating, setRating] = useState<SingleRating[]>([]);
  const [count, setCount] = useState<number>(0);
  const [page, setPage] = useState<number>(1);
  const onPageChange = (e: any, newPage: number) => {
    setPage(newPage + 1);
  };
  const [open, setOpen] = useState<boolean>(false);
  const [selectedId, setSelectedId] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [deleteById] = useDeleteRatingByIdMutation();
  const [anchorEl1, setAnchorEl1] = React.useState<null | HTMLElement>(null);
  const open1 = Boolean(anchorEl1);
  const handleClick1 = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl1(event.currentTarget);
  };
  const handleClose1 = () => {
    setAnchorEl1(null);
  };

  const [anchorEl2, setAnchorEl2] = React.useState<null | HTMLElement>(null);
  const open2 = Boolean(anchorEl2);
  const handleClick2 = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl2(event.currentTarget);
  };
  const handleClose2 = () => {
    setAnchorEl2(null);
  };

  const [anchorEl3, setAnchorEl3] = React.useState<null | HTMLElement>(null);
  const open3 = Boolean(anchorEl3);
  const handleClick3 = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl3(event.currentTarget);
  };
  const handleClose3 = () => {
    setAnchorEl3(null);
  };

  const getRatingAll = async () => {
    setIsLoading(true);
    try {
      const response = await getRating({
        id: id as string,
      }).unwrap();
      // setLoading(false);

      if (response?.statusCode === 200) {
        setRating(response?.data?.data);
        setCount(response?.data?.count);
      } else {
        // setRows([]);
      }
    } catch (error: any) {
      showError(error?.data?.message || '');
      // setLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDelete = async () => {
    setIsLoading(true);
    try {
      const response = await deleteById({
        id: selectedId,
      }).unwrap();
      setIsLoading(false);

      if (response?.statusCode === 200) {
        showToast('Deleted successfully');
        getRatingAll();
      }
    } catch (error: any) {
      showError(error?.data?.message || '');
      setIsLoading(false);
    }
  };

  const columns: GridColDef<(typeof rating)[number]>[] = [
    {
      flex: 0.8,
      minWidth: 200,
      field: 'name',
      headerName: 'User Name',
      editable: false,
      sortable: false,
    },

    {
      flex: 0.8,
      minWidth: 200,
      field: 'phone',
      headerName: 'Phone',
      editable: false,
      sortable: false,

      renderCell: ({ row }) => {
        return (
          <p>
            {row?.dialCode || '-'}
            {row?.phoneNo || '-'}
          </p>
        );
      },
    },
    // {
    //   flex: 0.8,
    //   minWidth: 200,
    //   field: "review",
    //   headerName: "Review",
    //   editable: false,
    //   sortable: false,

    // },
    {
      flex: 1,
      minWidth: 150,
      field: 'Rating',
      headerName: 'Rating',
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        const arr = new Array(row?.rating);
        return (
          <div className="star_rating">
            {[...arr].map((item, i: number) => (
              <StarIcon className="active" key={i} />
            ))}
          </div>
        );
      },
    },

    {
      flex: 0.1,
      minWidth: 80,
      field: 'action',
      headerName: 'Action',
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="table_actions">
            <Box>
              <IconButton
                onClick={() => {
                  setSelectedId(row?._id);
                  setOpen(true);
                }}
              >
                <Delete
                  sx={{
                    color: 'red',
                    ':hover': {
                      color: 'white',
                    },
                  }}
                />
              </IconButton>
            </Box>
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    getRatingAll();
  }, []);

  return (
    <>
      <div className="cards cards_100 table_card">
        <div className="cards_header">
          <div className="left_s">
            <h2>Ratings and Reviews</h2>
          </div>
          <div className="right_s">
            {/* <p>
              <span>Month</span>
              <span>Week</span>
              <span>Today</span>
            </p> */}
            {/* <Button className="btn btn_highlight">
              <img src="/static/images/upload_icon.svg" alt="Icon" /> Export
            </Button> */}
          </div>
        </div>
        <div className="sorting_table">
          <TableComponent
            columns={columns}
            rows={rating}
            count={count}
            page={page}
            onPageChange={onPageChange}
            loading={isLoading}
          />
        </div>
        <ConfirmationModal
          text={'Are you sure to delete this rating?'}
          openModal={open}
          setOpenModal={setOpen}
          handleSubmit={() => {
            handleDelete();
          }}
        />
        {/* <div className="text_center">
          <a href="javascript:void(0)">Show More</a>
        </div> */}
      </div>
    </>
  );
};

export default RatingsAndReviews;
